import React, { Component } from 'react';
import EventBus from "../common/EventBus.js";
import GlobalHelper from '../common/GlobalHelper.jsx';
import LoadingSpinner from '../common/spinner/loading.component.jsx';
import QuestionConversationChat from "../question-conversation/questionconversationchat.jsx";
import { TYPE_EMAIL } from '../state/conversation/ConversationThreadTypes.ts';
import ProposalMergeFields from "../template/MergeFields";
import { default as ContentTypes, default as SectionContentTypes } from "../template/sections/content/ContentTypes.jsx";
import FooterContentSection from "../template/sections/content/footer/section.component.jsx";
import ContentTypeSelector from "../template/sections/content/select.component.jsx";
import EditSectionModal from "../template/sections/editmodal.component.jsx";

class ProposalContent extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            variables: this.props.variables || null,
            isPdf: this.props.isPdf || false,
            isSample: this.props.isSample || false,
            isWord: this.props.isWord || false,
            isDummy: this.props.isDummy || false,
            editable: this.props.editable || false,
            onEdit: this.props.onEdit || function () { },
            showBranding: this.props.showBranding || false,
            modal: '',
            mobile: this.props.mobile || false,
            questionsChatDisabled: !isNaN(this.props.questionsChatDisabled) ? this.props.questionsChatDisabled : true,
            isInsidePreview: this.props.isInsidePreview || false,
            project: null,
            templateEmail: this.props.templateEmail || '',
        }
        this.closeModal = this.closeModal.bind(this)
        this.handleOpenModal = this.handleOpenModal.bind(this)
        this.refreshProposal = this.refreshProposal.bind(this)
        this.refreshProposalVariables = this.refreshProposalVariables.bind(this)
        this.changeChatButtonVisibility = this.changeChatButtonVisibility.bind(this)

        //event bus listeners
        EventBus.listen(EventBus.TopicProposalPreApproved, 'proposal-content', this.refreshProposalVariables)
        EventBus.listen(EventBus.TopicProposalSectionEditorOpen, 'edit-button-section-modal', this.handleOpenModal)
        EventBus.listen(EventBus.TopicProposalPreviewRefresh, 'edit-button-section-modal', this.refreshProposal)
        EventBus.listen(EventBus.TopicSignaturePadChanged, 'change-chat-button-visibility', this.changeChatButtonVisibility)
    }

    componentDidMount() {
        if (this.state.variables) {
            const documentInfoSection = this.state.variables.sections.find(s => s.attributes.contentType === 'document-info')
            if (documentInfoSection) {
                this.setState({
                    questionsChatDisabled: documentInfoSection.attributes.content.disableChat,
                })
            } else {
                this.setState({
                    questionsChatDisabled: true,
                })
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            variables: nextProps.variables || null,
            isPdf: nextProps.isPdf || false,
            isWord: nextProps.isWord || false,
            isDummy: nextProps.isDummy || false,
            mobile: nextProps.mobile || false,
            isInsidePreview: nextProps.isInsidePreview || false,
            project: nextProps.project || null,
            templateEmail: nextProps.templateEmail || '',
        })
    }

    handleOpenModal(event) {
        if (!this.state.editable) {
            return
        }
        this.setState({
            modal: <EditSectionModal
                onClose={this.closeModal}
                sectionId={event.getData().sectionId}
                documentId={this.state.variables.documentId}
                variables={this.state.variables}
                contentType={event.getData().contentType}
                currentRank={event.getData().position}
            />
        })
    }

    closeModal() {
        this.setState({
            modal: ''
        }, () => {
            if (this.state.onEdit) {
                this.state.onEdit()
            }
        })
    }

    refreshProposal() {
        if (this.state.onEdit) {
            this.state.onEdit()
        }
    }

    refreshProposalVariables(event) {
        this.setState({
            variables: event.getData().variables,
        })
    }

    changeChatButtonVisibility(event) {
        this.setState({
            questionsChatDisabled: event.getData().hideChatButton,
        })
    }

    isPriceListProposal() {
        return this.props.variables.proposalType === "price-list"
    }

    isTemplatePriceList() {
        return this.props.variables.quote.title === "Sample"
    }

    adjustPdfFontSize(printSize){
        const smallFontSize = "small-font"
        const mediumFontSize = "medium-font"
        const largeFontSize = "large-font"
        if (this.state.isPdf) {
            switch (printSize) {
              case "Medium":
                return mediumFontSize
              case "Large":
                return largeFontSize
              default:
                return smallFontSize
            }
        } else {
           return "final-proposal"
        }
    }

    render() {
        if (!this.state.variables) {
            return <LoadingSpinner marginTop="20px" />
        }
        
        const groups = [[]]
        for (let index in this.state.variables.sections) {
            
            const section = this.state.variables.sections[index]
            if (section.attributes.contentType === 'empty-space') {
                groups.push([])
            }

            if (this.isPriceListProposal() && !this.isTemplatePriceList()) {
                if (section.attributes.contentType === 'custom-form' &&
                    !ProposalMergeFields.includeDefinition(section.attributes.content.customField,
                        `${this.state.variables.quote.objectType}s`)) {
                    continue
                }
            }

            const component = ContentTypes.getSectionComponent(
                section,
                this.state.variables,
                this.state.isPdf,
                this.state.isDummy,
                this.state.isSample,
                this.state.isWord,
                this.state.editable,
                index,
                this.state.onEdit,
                this.state.mobile,
                this.state.templateEmail
            )
            if (component) {
                groups[groups.length - 1].push(component)
            }
        }
        let containerClass = !this.state.isPdf && !this.state.isWord ? 'col-xl-10 col-lg-12 col-sm-12' : 'col-12'
        if (this.state.editable) {
            containerClass = 'col-md-12 col-sm-12'
        }

        var poweredBy = this.state.editable || this.state.isWord ? '' : <FooterContentSection showBranding={this.state.showBranding} variables={this.state.variables} />

        const groupsToRender = groups.filter(g => g.length > 0)
        return <div>
            {this.state.modal}
            <div className={`row ui-has-modules justify-content-md-center ${this.adjustPdfFontSize(this.props.variables.global.printSize)}`} style={{
                fontFamily: this.state.variables.global.font + ', sans-serif', 
            }}>
                <div id={'proposal-content'} className={containerClass} style={this.state.isWord ? { width: '100%' } : {}}>
                    {groupsToRender.length > 0 ? groupsToRender.map((g, i) => {
                        if (this.state.isPdf) {
                            const row = []
                            if (i > 0) {
                                row.push(<div key={row.length} className={'separator row py-2 section-size'} >
                                    <div key={1} className={'col-12 px-0 py-2'} />
                                </div>)
                            }
                            row.push(g)
                            return row
                        } else {
                            return <div className="row" key={i}>
                                <div className={'ui-module-proposal col-12'}>
                                    {g}
                                </div>
                            </div>
                        }

                    }) : <div className="row box-size">
                        {this.state.editable ? <div className={'ui-module-proposal col-12'}>
                            <div className={'row justify-content-center'}>
                                <div id={'content-type-selector-new'} className={'col-6 py-3'}>
                                    <ContentTypeSelector
                                        type={this.state.variables.document.type}
                                        onChange={contentType => {
                                            SectionContentTypes.addNewSection(contentType, 0)
                                        }} />
                                </div>
                            </div>
                        </div> : ''}
                    </div>}
                    {this.props.isPdf ? "" : poweredBy}
                </div>
            </div>
            {
                !this.state.isPdf && !this.state.isWord && !this.state.isDummy && !this.isSample && !this.state.isInsidePreview &&
                !this.state.questionsChatDisabled && ['invoice', 'order', 'quote', 'contract'].includes(this.state.variables.document.type) &&
                <QuestionConversationChat
                    chatButtonClass="fixed-question-conversation-chat-btn"
                    variables={this.state.variables}
                    project={this.state.project}
                    selectedThread={GlobalHelper.getConversationThreadIndex(this.state.variables.project.conversationThreads, TYPE_EMAIL)}
                />
            }
        </div >
    }


}

export default ProposalContent





// WEBPACK FOOTER //
// ./src/proposal/content.component.jsx